import api from './index.js';

api.internals.register(api.accordion.AccordionSelector.GROUP, api.accordion.AccordionsGroup);

export default api;
